import { FunctionComponent } from 'react';
import styles from './../../../styles/CategoryTitleSection.module.scss';

type Props = {
    title: string;
    className?: string;
};
export const CategoryTitleSection: FunctionComponent<Props> = ({ title, className }) => {
    const bashClassName = className ? className : ''; // note: fix prettier :D
    return (
        <h2
            className={`${bashClassName} ${styles.container} d-flex flex-row justify-content-center align-items-center text-center font-playfair-700`}>
            {title}
        </h2>
    );
};
